<template>
  <div>
    <div class="col-md-12">
      <div class="row">
        <div class="categories">

          <div v-if="user.access > 5" class="pull-right">
            <button class="btn green margin-right-5" @click="showAddCategoryModal = true"><i class="fa fa-plus" aria-hidden="true"></i> Add category</button>
            <button v-if="currentCategory !== null" class="btn green" @click="showEditCategoryModal = true"><i class="fa fa-edit" aria-hidden="true"></i> Edit current category</button>
          </div>

          <button class="btn green margin-right-5 margin-bottom-20" :class="{'btn-outline' : currentCategory !== null}" @click="fetchCategory(null)">All Categories</button><button v-for="category in alphabeticalOrderCategories"
                  class="btn green margin-right-5 margin-bottom-20"
                  :class="{'btn-outline' : !currentCategory || currentCategory.id !== category.id}"
                  @click="fetchCategory(category.id)"
          >{{ category.title }}
          </button>
        </div>

        <template v-if="user.access > 5 && !loading && currentCategory !== null">
          <hr>
          <div class="upload">
            <div class="example-btn">
              <file-upload
                  class="btn green"
                  :post-action="uploadEndpoint"
                  :data="{'categoryId':currentCategory.id}"
                  :multiple="true"
                  :size="1024 * 1024 * 100"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  :input-id="'tutorial-upload-tutorial'"
                  :headers="{'token' : token}"
                  ref="upload">
                <i class="fa fa-plus"></i> Select files
              </file-upload>
              <button type="button" class="btn green" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
                Start Upload
              </button>
              <button type="button" class="btn green" v-else @click.prevent="$refs.upload.active = false">
                <i class="fa fa-stop" aria-hidden="true"></i> Stop Upload
              </button>
            </div>
            <ul>
              <li v-for="(file, index) in files" :key="file.id">
                <span>{{file.name}}</span> -
                <span>{{file.size}}</span> -
                <span v-if="file.error">{{file.error}}</span>
                <span v-else-if="file.success">success</span>
                <span v-else-if="file.active">active</span>
                <span v-else-if="file.active">active</span>
                <span v-else></span>
              </li>
            </ul>
          </div>
          <hr>
        </template>

        <vue-spinner v-if="loading"></vue-spinner>

        <div v-if="!loading" class="tutorials">
          <div class="row">
            <div v-for="tutorial in tutorials" class="col-md-3 col-sm-3 col-xs-4 tutorial-wrapper">
              <div class="tutorial" :style="{'background-image': 'url('+thumbUrl(tutorial.thumbFile)+')'}">
                <img v-if="!tutorial.thumbFile" class="placeholder" src="/static/layouts/layout2/img/logo-default.png" alt="">

                <div class="buttons">
                  <a class="btn green" @click.prevent="playTutorial(getTutorialUrl(tutorial.file))">Play</a>
                  <button v-if="user.access > 5" class="btn green" @click.prevent="onTutorialSettingsClick(tutorial.id)">Settings</button>
                </div>
              </div>
              <div class="headers">
                <h1 class="tutorial-header">{{tutorial.header}}</h1>
                <h2 class="tutorial-subheader">{{tutorial.subheader}}</h2>
              </div>
            </div>
          </div>
        </div>


      </div>


    </div>

    <add-category-modal v-if="showAddCategoryModal"
                        v-on:display="showAddCategoryModal = $event"
                        v-on:category-added="categoryAdded"
    ></add-category-modal>

    <edit-category-modal v-if="showEditCategoryModal && currentCategory !== null"
                         :id="currentCategory.id"
                         v-on:display="showEditCategoryModal = $event"
                         v-on:category-updated="categoryUpdated"
                         v-on:category-removed="categoryRemoved"
    ></edit-category-modal>

    <tutorial-settings-modal v-if="showTutorialSettingsModal"
                          :id="currentTutorialId"
                          :categories="categories"
                          v-on:display="showTutorialSettingsModal = $event"
                          v-on:tutorial-updated="tutorialUpdated"
                          v-on:tutorial-removed="tutorialRemoved"
    ></tutorial-settings-modal>

    <video-tutorial-modal :url="currentTutorialUrl"/>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import {BACKEND_URL, BUCKET_URL, HTTP, ERROR} from "@/http-common";
  import {mapGetters} from 'vuex';
  import Spinner from '@/components/Spinner';
  import VueUploadComponent from 'vue-upload-component';
  import AddCategoryModal from "./AddCategoryModal";
  import EditCategoryModal from "./EditCategoryModal";
  import TutorialSettingsModal from "./TutorialSettingsModal";
  import VideoTutorialModal from "@/components/modals/VideoTutorialModal";

  export default {
    data() {
      return {
        showAddCategoryModal: false,
        showEditCategoryModal: false,
        showTutorialSettingsModal: false,
        currentTutorialId: null,
        currentTutorialUrl: null,
        categories: [],
        currentCategory: {},
        tutorials: [],
        loading: false,
        files: [],
        uploadEndpoint: BACKEND_URL + 'tutorials/upload-file'
      }
    },
    components: {
      'vue-spinner': Spinner,
      'file-upload': VueUploadComponent,
      AddCategoryModal,
      EditCategoryModal,
      TutorialSettingsModal,
      VideoTutorialModal,
    },
    mounted() {
      this.fetchCategories().then(() => {
          if (this.categories.length) {
            this.fetchCategory(null);
          }
        }
      )
    },
    computed: {
      ...mapGetters({
        user: 'getUser'
      }),
      alphabeticalOrderCategories(){
        return this.categories.sort((a, b) => {
          if (
            Object.prototype.hasOwnProperty.call(a, 'title') &&
            Object.prototype.hasOwnProperty.call(b, 'title')
          ) {
            let titleA = a.title.toLowerCase();
            let titleB = b.title.toLowerCase();

            if (titleA > titleB) {
              return 1
            }
            if (titleA < titleB) {
              return -1
            }
          }
          return 0
        })
      },
      token: function () {
        return localStorage.getItem('id_token');
      },
    },
    methods: {
      fetchCategories() {
        this.loading = true;
        return HTTP.get('tutorials/categories-index').then(response => {
          ERROR(response);
          this.categories = response.data.data.categories;
          this.loading = false;
        }).catch(error => {
          this.$notify({
            type: 'error',
            text: 'Something went wrong while trying to get tutorials.'
          });
          this.loading = false;
        });
      },
      handleError(error) {
        if (error.response && error.response.status === 504) {
          this.$notify({
            type: 'error',
            text: 'Request timed out, please try again later.'
          });
        } else {
          this.$notify({
            type: 'error',
            text: 'Something went wrong while trying to get tutorials from all categories.'
          });
        }
      },
      fetchCategory(categoryId) {
        this.loading = true;
        if(!categoryId) {
          return HTTP.get('tutorials/index').then(response => {
            ERROR(response);
            this.currentCategory = null;
            this.tutorials = response.data.data.tutorials;
            this.loading = false;
          }).catch(error => {
            this.handleError(error);
            this.loading = false;
          })
        }
        return HTTP.get('tutorials/category/' + categoryId).then(response => {
          ERROR(response);
          this.currentCategory = response.data.data.category;
          this.tutorials = response.data.data.tutorials;
          this.loading = false;
        }).catch(error => {
          this.handleError(error);
          this.loading = false;
        });
      },
      categoryAdded() {
        this.fetchCategories();
      },
      categoryUpdated() {
        this.fetchCategories();
      },
      categoryRemoved() {
        this.fetchCategories();
      },
      tutorialUpdated() {
        this.fetchCategory(this.currentCategory ? this.currentCategory.id : null);
      },
      tutorialRemoved() {
        this.fetchCategory(this.currentCategory ? this.currentCategory.id : null);
      },
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          console.log('add', newFile)
        }
        if (newFile && oldFile) {
          console.log('update', newFile)
        }
        if (!newFile && oldFile) {
          console.log('remove', oldFile)
        }
      },
      onTutorialSettingsClick(tutorialId) {
        this.currentTutorialId = tutorialId;
        this.showTutorialSettingsModal = true;
      },
      getTutorialUrl(tutorialName) {
        if (tutorialName) {
          return BUCKET_URL + 'tutorials/' + tutorialName;
        }
        return '';
      },
      thumbUrl(thumbFile) {
        if (thumbFile) {
          return BUCKET_URL + 'tutorials/' + thumbFile;
        }
        return '';
      },
      playTutorial(tutorialUrl) {
        this.currentTutorialUrl = tutorialUrl;
        $('#video-tutorial-dialog').modal('show').on('hide.bs.modal', () => {
          this.currentTutorialUrl = null;
        });
      },
    },
    watch: {
      files: function (files) {
        if (!files.length) {
          return;
        }
        if (files.every(item => item.success)) {
          this.fetchCategory(this.currentCategory.id);
        }
      }
    }
  }
</script>

<style scoped lang="scss">

  .categories {

    @media (max-width: 767px) {
      .btn {
        font-size: 12px;
      }
      .margin-bottom-20 {
        margin-bottom: 10px !important;
      }
    }

  }

  .tutorials {

    .tutorial-wrapper {
      margin-bottom: 15px;
    }

    @media (max-width: 479px) {
      .tutorial-wrapper {
        width: 50% !important;
      }
    }

    .headers {
      h1, h2 {
        font-size: 14px;
      }

      height: 4em;

      @media (max-width: 1023px) {
        h1, h2 {
          font-size: 12px;
        }
        height: 6em;
      }

      @media (max-width: 767px) {
        h1, h2 {
          font-size: 13px;
        }
        height: 7em;
      }

      @media (max-width: 479px) {
        h1, h2 {
          font-size: 12px;
        }
        height: 6em;
      }

    }

    h1 {
      text-align: center;
      font-weight: bold;
      margin: 5px 0 5px 0;

    }

    h2 {
      text-align: center;
      margin: 0;
    }

    .tutorial {
      position: relative;
      /*border: 1px #d09f23 solid;*/
      border: 1px #ddd solid;
      height: 20vw;
      background-size: cover;
      background-position: center center;

      @media (max-width: 767px) {
        height: 28vw;
      }

      @media (max-width: 479px) {
        height: 40vw;
      }


      &:hover {
        .buttons {
          display: flex;
        }
      }

      .placeholder {
        display: block;
        margin: 0 auto;
        margin-top: 8vw;
      }

      .buttons {
        display: none;
        position: absolute;
        bottom: 15px;
        width: 100%;
        justify-content: center;

        button, a {
          margin-right: 5px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .upload ul {
    margin-top: 10px;
    margin-left: 20px;
    padding-left: 0;
  }

</style>



// WEBPACK FOOTER //
// HelpTutorialsIndex.vue?d25f2a50